module.exports = __webpack_public_path__ + "static/media/level1.cf348453.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/firebag/level1.png
// module id = 1230
// module chunks = 0